<!-- The list's own title, where its host has no header of its own: the Messages page column, and a context's list (a
     case or a project). On the Chat panel the magic bar's header reads "Chat" (ITP-E-203-01), as carbon's does. -->
<div class="component-heading flex flex-row justify-start items-center" *ngIf="showHeading">{{contextTitle}}</div>



<!--<div class="data-tracking-container hide">-->
<!--  <div class="headers m-b-10 m-t-20">-->
<!--    <span matTooltip="GMT-Covered Tax Adjustments">GMT-Covered Tax Adjustments</span>-->
<!--    <i class="fa-regular fa-ellipsis-vertical pointer" [matMenuTriggerFor]="editMenu"></i>-->
<!--  </div>-->
<!--  <mat-menu #editMenu="matMenu">-->
<!--    <button mat-menu-item (click)="navigateToNewConversation()" particleAnalytics-->
<!--      analyticsCategory="action-type-cell-viewer" analyticsAction="action-dropdown" analyticsName="newConversation">-->
<!--      <span>View Data Reconciliation</span>-->
<!--    </button>-->
<!--    <button mat-menu-item (click)="onHashTagClick('DAC6')" particleAnalytics analyticsCategory="action-type-cell-viewer"-->
<!--      analyticsAction="action-dropdown" analyticsName="newConversation">-->
<!--      <span>View Interactive Chart</span>-->
<!--    </button>-->
<!--  </mat-menu>-->
<!--  <mat-form-field appearance="outline" class="w-p-100">-->
<!--    <mat-label>Hello world</mat-label>-->
<!--    <mat-select placeholder="Entity" formControlName="entity">-->
<!--      <mat-option>Hello world</mat-option>-->
<!--      <mat-option>Hello world 2</mat-option>-->
<!--      <mat-option>Hello worl3</mat-option>-->
<!--    </mat-select>-->
<!--    <button class="mat-clear-btn">-->
<!--      <i class="fa-regular fa-xmark"></i>-->
<!--    </button>-->
<!--  </mat-form-field>-->
<!--  <mat-accordion class="list-view-accordian">-->
<!--    <mat-expansion-panel>-->
<!--      <mat-expansion-panel-header>-->
<!--        <mat-panel-title>-->
<!--          <span class="icon-container other-source-icon"></span>-->
<!--            <span class="title">PluginReport.qnr</span> &nbsp;-->
<!--          <span class="count">(27)</span>-->
<!--        </mat-panel-title>-->
<!--        <button class="open-in-new"><i class="fa-regular fa-arrow-up-right-from-square"></i></button>-->
<!--      </mat-expansion-panel-header>-->
<!--      <ul>-->
<!--        <li> <span class="title" matTooltip="Beginning Assets">Beginning Assets</span>&nbsp; <span class="counts">(75 records)</span></li>-->
<!--        <li> <span class="title" matTooltip="Ending Assets">Ending Assets</span>&nbsp; <span class="counts">(75 records)</span></li>-->
<!--      </ul>-->
<!--    </mat-expansion-panel>-->
<!--  </mat-accordion>-->

<!--  <mat-accordion class="data-tracking-mat-accordion hide">-->
<!--    <mat-expansion-panel>-->
<!--      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">-->
<!--        <mat-panel-title>&nbsp;&nbsp;&nbsp;-->
<!--          <span class="icon-container blank-icon"></span>-->
<!--          Blank Field &nbsp;<span class="count">(7)</span>-->
<!--        </mat-panel-title>-->
<!--      </mat-expansion-panel-header>-->
<!--      <mat-expansion-panel>-->
<!--        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">-->
<!--          <mat-panel-title>-->

<!--            ONESOURCE Tax Provision-->
<!--          </mat-panel-title>-->
<!--        </mat-expansion-panel-header>-->
<!--        <ul>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--        </ul>-->
<!--      </mat-expansion-panel>-->
<!--    </mat-expansion-panel>-->
<!--    <mat-expansion-panel>-->
<!--      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">-->
<!--        <mat-panel-title>-->
<!--          <span class="icon-container eat-workflow-icon"></span>-->
<!--          E.A.T. Workflow &nbsp;<span class="count">(27)</span>-->
<!--        </mat-panel-title>-->
<!--      </mat-expansion-panel-header>-->
<!--      <mat-expansion-panel>-->
<!--        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">-->
<!--          <mat-panel-title>-->

<!--            ONESOURCE Tax Provision-->
<!--          </mat-panel-title>-->
<!--        </mat-expansion-panel-header>-->
<!--        <ul>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--        </ul>-->
<!--      </mat-expansion-panel>-->
<!--    </mat-expansion-panel>-->
<!--    <mat-expansion-panel>-->
<!--      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">-->
<!--        <mat-panel-title>-->

<!--          <span class="icon-container contact-icon"></span>-->
<!--          Orbitax Contact &nbsp;<span class="count">(27)</span>-->
<!--        </mat-panel-title>-->
<!--      </mat-expansion-panel-header>-->
<!--      <mat-expansion-panel>-->
<!--        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">-->
<!--          <mat-panel-title>-->

<!--            ONESOURCE Tax Provision-->
<!--          </mat-panel-title>-->
<!--        </mat-expansion-panel-header>-->
<!--        <ul>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--        </ul>-->
<!--      </mat-expansion-panel>-->
<!--      <mat-expansion-panel>-->
<!--        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">-->
<!--          <mat-panel-title>-->

<!--            Another Pipeline Name-->
<!--          </mat-panel-title>-->
<!--        </mat-expansion-panel-header>-->
<!--        <ul>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--        </ul>-->
<!--      </mat-expansion-panel>-->
<!--    </mat-expansion-panel>-->
<!--    <mat-expansion-panel>-->
<!--      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">-->
<!--        <mat-panel-title>-->
<!--          <span class="icon-container upload-icon"></span>-->
<!--          Upload Template &nbsp;<span class="count">(27)</span>-->
<!--        </mat-panel-title>-->
<!--      </mat-expansion-panel-header>-->
<!--      <mat-expansion-panel>-->
<!--        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">-->
<!--          <mat-panel-title>-->

<!--            ONESOURCE Tax Provision-->
<!--          </mat-panel-title>-->
<!--        </mat-expansion-panel-header>-->
<!--        <ul>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--        </ul>-->
<!--      </mat-expansion-panel>-->
<!--    </mat-expansion-panel>-->
<!--    <mat-expansion-panel>-->
<!--      <mat-expansion-panel-header [collapsedHeight]="'50'" [expandedHeight]="'50'">-->
<!--        <mat-panel-title>-->
<!--          <span class="icon-container user-input-icon"></span>&nbsp;&nbsp;-->
<!--          User Input &nbsp;<span class="count">(0)</span>-->
<!--        </mat-panel-title>-->
<!--      </mat-expansion-panel-header>-->
<!--      <mat-expansion-panel>-->
<!--        <mat-expansion-panel-header [collapsedHeight]="'auto'" [expandedHeight]="'auto'">-->
<!--          <mat-panel-title>-->

<!--            ONESOURCE Tax Provision-->
<!--          </mat-panel-title>-->
<!--        </mat-expansion-panel-header>-->
<!--        <ul>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--          <li> <span class="text" matTooltip="Current Tax Expense as per GAAP">Current Tax Expense as per GAAP</span> <span class="count">(7)</span></li>-->
<!--        </ul>-->
<!--      </mat-expansion-panel>-->
<!--    </mat-expansion-panel>-->
<!--  </mat-accordion>-->
<!--</div>-->


<div class="details-container hide">
  <h5>Details</h5>
  <table class="data-table">
    <tbody>
    <tr>
      <td class="title">Entity Code:</td>
      <td class="value">1065</td>
    </tr>
    <tr>
      <td class="title">Entity Name:</td>
      <td class="value">Mega Austria Branch</td>
    </tr>
    <tr>
      <td class="title">Jurisdiction:</td>
      <td class="value">Beginning Tangible Assets</td>
    </tr>
    <tr>
      <td class="title">Data Source:</td>
      <td class="value">
        <a>GeneralLedger.xlsx</a>
      </td>
    </tr>
    </tbody>
  </table>
</div>
<div class="history-container hide">
  <h5>History</h5>
  <ul>
    <li class="active">
      <div class="file-icon"></div>
      <div class="value-container">
        <div class="value">74,170</div>
        <ul class="informations">
          <li class="date">06/10/2023</li>
          <li class="file-details">GeneralLedger.xlsx</li>
        </ul>
      </div>
    </li>
    <li>
      <div class="file-icon"></div>
      <div class="value-container">
        <div class="value">50,170</div>
        <ul class="informations">
          <li class="date">03/23/2023</li>
          <li class="file-details">User Input (Monique Greer)</li>
        </ul>
      </div>
    </li>
    <li>
      <div class="file-icon"></div>
      <div class="value-container">
        <div class="value">Blank</div>
        <ul class="informations">
          <li class="date">03/23/2023</li>
        </ul>
      </div>
    </li>
  </ul>
</div>

<!-- THE OVERVIEW'S TABS (ITP-E-203-02): carbon's Conversations | Members, on the Chat panel only. The Messages page keeps
     its own layout, and a context's list is conversations alone. -->
<div class="chat-tabs" *ngIf="showTabs">
  <div class="chat-seg" role="tablist" aria-label="Chat overview">
    <button type="button" role="tab" class="chat-seg__segment" *ngFor="let option of overviewTabs"
            [attr.aria-selected]="overviewTab === option.id" (click)="setOverviewTab(option.id)">{{ option.label }}</button>
  </div>
</div>

<chat-members-tab *ngIf="showTabs && overviewTab === 'members'" [clearForDisc]="showNewChat"
                  (memberPicked)="openDirectChat($event)"></chat-members-tab>

<ng-container *ngIf="!showTabs || overviewTab === 'conversations'">
<!-- FIND AND FILTER on the Messages page (ITP-E-204-08), carbon's /meet/messages `.itp-msgr__tools` (page.tsx:476-495):
     the search at the band's width, then the five-way filter as a segmented control of equal segments. -->
<div class="chat-tools" *ngIf="isPageHost; else panelFind">
  <div class="chat-search-field">
    <i class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
    <input type="search" [value]="searchText" (input)="onSearchChanged($any($event.target).value)"
           placeholder="Search conversations" aria-label="Search conversations">
  </div>
  <div class="chat-seg" role="radiogroup" aria-label="Filter conversations">
    <button *ngFor="let option of filters; let index = index" type="button" role="radio" class="chat-seg__segment"
            [attr.aria-checked]="filter === option.id" (click)="onFilterChanged(option.id)"
            (keydown)="onFilterKey($event, index)">{{ option.label }}</button>
  </div>
</div>
<ng-template #panelFind>
<!-- FIND AND FILTER on the Chat panel (ITP-E-194-03), in carbon's form (ITP-E-203-01): the search field, then the filter
     chips, 28px pills that scroll sideways rather than wrap, the chosen one inverted. -->
<div class="chat-search">
  <div class="chat-search-field">
    <i class="fa-regular fa-magnifying-glass" aria-hidden="true"></i>
    <input type="search" [value]="searchText" (input)="onSearchChanged($any($event.target).value)"
           placeholder="Search conversations" aria-label="Search conversations">
  </div>
</div>
<div class="chat-filter" role="radiogroup" aria-label="Filter conversations">
  <button *ngFor="let option of filters" type="button" role="radio" class="chat-filter__chip"
          [class.chat-filter__chip--on]="filter === option.id" [attr.aria-checked]="filter === option.id"
          (click)="onFilterChanged(option.id)">{{ option.label }}</button>
</div>
</ng-template>

<!-- ARCHIVED IS A PLACE (B-07): a quiet row at the head of the list says how many are there and opens them; inside, a
     band names the place and leads back. Neither is drawn with nothing archived. -->
<div class="chat-band" *ngIf="showArchived">
  <span class="chat-band__title">Archived</span>
  <button type="button" class="chat-icon-button" (click)="closeArchived()" aria-label="Close archived conversations"
          matTooltip="Close archived conversations"><i class="fa-regular fa-xmark" aria-hidden="true"></i></button>
</div>
<button *ngIf="canArchive && !showArchived && archivedCount" type="button" class="chat-archived" (click)="openArchived()">
  <i class="fa-regular fa-box-archive" aria-hidden="true"></i>
  <span class="chat-archived__label">Archived</span>
  <span class="chat-archived__count">{{ archivedCount }}</span>
</button>

<div class="chat-scroll" [class.chat-scroll--clear]="showNewChat" *ngIf="!displayActionWaitScreen">
  <ul class="chat-list" *ngIf="visibleConversations.length">
    <ng-container *ngFor="let conversation of visibleConversations; trackBy: trackById">
      <li class="chat-list__item" *ngIf="conversation.titleAvatarInfo || conversation.isGroupConversation">
        <button type="button" class="chat-row" (click)="navigateToConversation(conversation)"
                [class.is-open]="isPageHost && conversation.id === selectedConversationId"
                [attr.aria-current]="isPageHost && conversation.id === selectedConversationId ? 'true' : null">
          <!-- THE FACE, 44px: a person's photo or initials with the presence dot (ITP-E-194-09, B-15); a group's two
               members as initials discs at 68%; a case keeps its own mark. -->
          <span class="chat-row__face" aria-hidden="true">
            <collaboration-avatar *ngIf="conversation.sourceType === 'DAC6'; else personOrGroup"
                                  [gravatarInfo]="conversation.titleAvatarInfo" [showCaseAvatar]="true"
                                  [showGroupAvatar]="conversation.isGroupConversation"></collaboration-avatar>
            <ng-template #personOrGroup>
              <span class="chat-faces" *ngIf="conversation.isGroupConversation; else person">
                <ngx-stored-gravatar *ngFor="let face of groupFacesOf(conversation); let first = first" [email]="face.email"
                                     [name]="face.name" [style]="first ? groupFaceStyle : groupFaceRingStyle"></ngx-stored-gravatar>
              </span>
              <ng-template #person>
                <messenger-presence-face [status]="faceStatus(conversation)" [size]="44">
                  <ngx-stored-gravatar [email]="conversation.titleAvatarInfo?.email" [name]="personName(conversation)"
                                       [style]="faceStyle"></ngx-stored-gravatar>
                </messenger-presence-face>
              </ng-template>
            </ng-template>
          </span>
          <span class="chat-row__text" *ngIf="lineTwoOf(conversation) as line">
            <!-- LINE ONE: the name, the scope chip, the reader's own marks (B-05 / B-06), and when. -->
            <span class="chat-row__line">
              <span class="chat-row__name">{{ conversation?.title }}</span>
              <span *ngIf="scopeChips[conversation.id] as chip" class="scope-chip" [matTooltip]="chip.title">
                <i [class]="chip.icon" aria-hidden="true"></i>{{ chip.label }}
              </span>
              <i *ngIf="line.pinned" class="fa-solid fa-thumbtack chat-row__mark" role="img" aria-label="Pinned"
                 matTooltip="Pinned"></i>
              <i *ngIf="line.muted" class="fa-solid fa-bell-slash chat-row__mark" role="img" aria-label="Muted"
                 matTooltip="Muted"></i>
              <span class="chat-row__stamp">{{ stampOf(conversation) }}</span>
            </span>
            <!-- LINE TWO: what is waiting here, in carbon's order (chat-list-format `lineTwo`). -->
            <span class="chat-row__line">
              <span class="chat-row__last" [ngSwitch]="line.lead">
                <ng-container *ngSwitchCase="'draft'"><span class="chat-row__draft">Draft</span> {{ draftOf(conversation) }}</ng-container>
                <!-- A call row (D-18, ITP-E-189-11) keeps its look (D-12): the call as it was for this viewer, no name. In
                     the Calls filter, a row whose last message is not a call shows its last stored call the same way (B-03). -->
                <ng-container *ngSwitchCase="'missed'">
                  <ng-container *ngTemplateOutlet="callLine; context: {$implicit: callOf(conversation)}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchCase="'call'">
                  <ng-container *ngTemplateOutlet="callLine; context: {$implicit: callOf(conversation)}"></ng-container>
                </ng-container>
                <ng-container *ngSwitchDefault>
                  <i *ngIf="line.tick as tick" class="chat-row__tick" [ngClass]="[messageTicks[tick].icon, 'chat-row__tick--' + tick]"
                     role="img" [attr.aria-label]="messageTicks[tick].label" [matTooltip]="messageTicks[tick].label"></i>{{ previewOf(conversation) }}
                </ng-container>
              </span>
              <!-- B-02: somebody mentioned the reader. -->
              <span *ngIf="line.mention" class="chat-row__count" role="img" aria-label="You were mentioned"
                    matTooltip="You were mentioned">@</span>
              <!-- The count, or a bare disc for a conversation marked unread by hand (B-08). -->
              <span *ngIf="line.count || line.dot" class="chat-row__count" [class.chat-row__count--quiet]="line.quiet"
                    [class.chat-row__count--dot]="line.dot"
                    [attr.aria-label]="line.count ? line.count + ' unread' : 'Marked as unread'">{{ line.count || '' }}</span>
              <!-- A call row keeps its ticks here, as they were (D-12). -->
              <span class="chat-row__call-ticks" *ngIf="conversation.lastMessage?.isMine && conversation.lastMessage?.callInvitationId">
                <i *ngIf="conversation.lastMessage.readStatus === 'AllRead'" class="fal fa-check-double all-seen "></i>
                <i *ngIf="conversation.lastMessage.readStatus === 'Unread'" class="fal fa-check not-seen"></i>
                <i *ngIf="conversation.lastMessage.readStatus === 'SomeRead'" class="fal fa-check partically-seen"></i>
              </span>
            </span>
          </span>
        </button>
        <!-- THE ROW'S OWN MENU: a sibling of the row's button, revealed on hover and focus, holding Open in Messages
             (ITP-E-268-02) and what a flag has switched on (B-05..B-08). With none of them there is no control at all. -->
        <button *ngIf="hasRowMenu" type="button" class="chat-icon-button chat-list__more" [matMenuTriggerFor]="rowMenu"
                [matMenuTriggerData]="{conversation: conversation}"
                [attr.aria-label]="'Actions for the conversation with ' + conversation?.title"
                particleAnalytics analyticsCategory="conversation" analyticsAction="more-btn">
          <i class="fa-regular fa-ellipsis" aria-hidden="true"></i>
        </button>
      </li>
    </ng-container>
  </ul>
  <a *ngIf="showViewMoreInConversationList" class="link-color view-more" title="click to show more conversations"
     (click)="viewMoreConversation()">
    <span>View more</span>
  </a>
  <div *ngIf="conversationList && !visibleConversations.length" class="chat-empty" role="status">{{ emptyText }}</div>
</div>
</ng-container>

<ng-template #callLine let-call>
  <i class="fa-solid" [class.fa-phone]="call.callType !== 'Video'"
     [class.fa-video]="call.callType === 'Video'" aria-hidden="true"></i>&nbsp;<span>{{ callPreview(call) }}</span>
</ng-template>

<!-- Open in Messages and a divider first (ITP-E-268-02), then ORGANISE (ITP-E-194-04), in carbon's order: Pin, Mark as
     unread, Archive, then the mute lengths or Unmute. -->
<mat-menu #rowMenu="matMenu" xPosition="before" [overlapTrigger]="false">
  <ng-template matMenuContent let-conversation="conversation">
    <ng-container *ngIf="canOpenInMessages(conversation)">
      <button mat-menu-item (click)="openInMessages(conversation)">
        <i class="{{ OPEN_IN_MESSAGES.icon }}" aria-hidden="true"></i>&nbsp;<span>{{ OPEN_IN_MESSAGES.label }}</span>
      </button>
      <mat-divider *ngIf="canPin || canMarkUnread || canArchive || canMute"></mat-divider>
    </ng-container>
    <button mat-menu-item *ngIf="canPin" (click)="togglePinned(conversation)">
      <i class="fa-regular fa-thumbtack" aria-hidden="true"></i>&nbsp;<span>{{ pinned[conversation.id] ? 'Unpin' : 'Pin' }}</span>
    </button>
    <button mat-menu-item *ngIf="canMarkUnread && markedUnread[conversation.id]" (click)="setMarkedUnread(conversation, false)">
      <i class="fa-regular fa-envelope-open" aria-hidden="true"></i>&nbsp;<span>Mark as read</span>
    </button>
    <button mat-menu-item *ngIf="canMarkUnread && !markedUnread[conversation.id] && !(conversation.unreadMessageCount > 0)"
            (click)="setMarkedUnread(conversation, true)">
      <i class="fa-regular fa-envelope-dot" aria-hidden="true"></i>&nbsp;<span>Mark as unread</span>
    </button>
    <button mat-menu-item *ngIf="canArchive" (click)="toggleArchived(conversation)">
      <i class="fa-regular fa-box-archive" aria-hidden="true"></i>&nbsp;<span>{{ archived[conversation.id] ? 'Unarchive' : 'Archive' }}</span>
    </button>
    <ng-container *ngIf="canMute">
      <mat-divider *ngIf="canPin || canMarkUnread || canArchive"></mat-divider>
      <button mat-menu-item *ngIf="isMuted(conversation)" (click)="unmute(conversation)">
        <i class="fa-regular fa-bell" aria-hidden="true"></i>&nbsp;<span>Unmute</span>
      </button>
      <ng-container *ngIf="!isMuted(conversation)">
        <button mat-menu-item *ngFor="let length of muteLengths" (click)="mute(conversation, length.id)">
          <i class="fa-regular fa-bell-slash" aria-hidden="true"></i>&nbsp;<span>{{ length.label }}</span>
        </button>
      </ng-container>
    </ng-container>
  </ng-template>
</mat-menu>

<!-- THE NEW CHAT DISC (carbon `.itp-chat-panel__new`): 48px, lower right, over both tabs; it raises the New chat
     sheet. The Messages page has its own New conversation button, which raises the same sheet. -->
<button *ngIf="showNewChat" type="button" class="chat-new" (click)="navigateToNewConversation()" aria-label="New chat"
        matTooltip="New chat" particleAnalytics analyticsCategory="action-type-cell-viewer" analyticsAction="action-button">
  <i class="fa-solid fa-plus" aria-hidden="true"></i>
</button>

<!-- THE NEW CHAT SHEET (ITP-E-203-04): over this list, from the disc or the Messages page's New conversation. -->
<chat-new-chat-sheet *ngIf="newChatOpen" (closed)="closeNewChat()" (directPicked)="onNewChatDirect($event)"
                     (groupPicked)="onNewChatGroup($event)"></chat-new-chat-sheet>

<particle-right-sidebar-wait-screen *ngIf="displayActionWaitScreen"></particle-right-sidebar-wait-screen>
